export enum NetworkItemType {
  NetworkProfile,
  Block,
  NpaNxx,
  Lrn,
  SpidProfile
}
